// extracted by mini-css-extract-plugin
export default {"rating":"Cz-z","numberOfStars":"Dz-z","count":"Ez-z","barGraphSpacing":"Fz-z","barGraph":"Gz-z"};